// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"78":"5de4c01e","162":"e253b1ea","249":"078771dc","320":"6b5ee90c","322":"9c20e6ae","416":"5e2e8f0d","423":"376c94e5","537":"e2bd7783","577":"ef0bb5e2","601":"a45c7315","624":"d07748ea","754":"7beb56ad","767":"20b71765","789":"eaafa679","970":"6e0ad395"}[chunkId] + ".js";
};